import { FC, Fragment, memo } from "react"
import { useTranslation } from "react-i18next"
import styles from "./BattleField.module.scss"
import { IBattleFieldProps } from "./types"
import { BattleFieldCell } from "./ui/BattleFieldCell"

const COLUMNS = 4
const LABEL_KEYS = [
  "screen.back",
  "screen.front",
  "screen.front",
  "screen.back"
]

const BattleFieldComponent: FC<IBattleFieldProps> = ({ cells, onMove }) => {
  const { t } = useTranslation("battle")

  if (cells.length === 0) {
    return null
  }

  return (
    <div className={styles.BattleField}>
      <div className={styles.BattleField_grid}>
        {cells.map((cell, index) => (
          <Fragment key={cell.key}>
            <BattleFieldCell cell={cell} onMove={onMove} />
            {index % COLUMNS === 1 && (
              <span className={styles.BattleField_spacer} aria-hidden="true" />
            )}
          </Fragment>
        ))}
      </div>
      <div className={styles.BattleField_grid}>
        {LABEL_KEYS.map((key, index) => (
          <Fragment key={index}>
            <span className={styles.BattleField_label}>{t(key)}</span>
            {index === 1 && (
              <span className={styles.BattleField_spacer} aria-hidden="true" />
            )}
          </Fragment>
        ))}
      </div>
    </div>
  )
}

export const BattleField = memo(BattleFieldComponent)
